import { LegadoClient } from "../../../../../../../../Wrap/Api/Legado/Legado";
import { LegadoConfigClient } from "../../../../../../../../Wrap/Api/Legado/LegadoConfig";
import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { LegadoConfigDispatcher } from "../../../Store/Variables";

export class LegadoAction {
    public static get(
        hierarchyId: string[],
        callback?: (url: string) => any
    ): void {
        const client = new LegadoClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((result) => {
            if (callback) {
                callback(result);
            }
        });

        promise.onError((err) => {
            console.error(err);
        });
    }
    
    public static isLegadoEnabled(
            callBack?: (flag: boolean) => void) {
        const configClient = new LegadoConfigClient();
        const promise = configClient.get();
        promise.onSuccess((result) => {
            LegadoConfigDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: result,
            });
            if (callBack) {
                callBack(result);
            }
        });
    }
}